import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Divider } from "../../components/styles";

import {
  Background,
  LayoutMain,
  MainHeadline,
  Textsection,
  TemplateOffer,
  InfoOffer,
  Contactform,
  NoOfferFound,
} from "../../components/common";
import { Row, Col } from "react-bootstrap";
import offers from "../../data/offersMountainguide";
import "./Mountainguide.css";

const Mountainguide = ({ headline = "BERGFÜHRER" }) => {
  const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;
  const [selectedOffer, setSelectedOffer] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
	// clear offer selection whenever we land on the main page
	// (independent of load/unload):
	if (location.pathname === '/mountainguide') {
		setSelectedOffer(null);
	}
  }, [location.pathname]);

  const handleOfferClick = (id) => {
    const selectedOffer = offers.find((offer) => offer.id === id);
    // add a (dummy) page to history stack to navigate back properly:
    navigate(`/mountainguide/offer`);
    setSelectedOffer(selectedOffer);
  };

  const handleBookingClick = (id) => {
    navigate(`/mountainguide`); // return here after navigating back from booking
    navigate(`/booking/${id}`);
  };

  const handleReturnClick = () => {
    navigate(`/mountainguide`);
  };

  // Filter offers based on categories
  const climbingOffers = offers.filter(
    (offers) => offers.category === "climbing"
  );
  //const hochWestOffer = offers.filter(
  //  (offers) => offers.category === "hochtourWest"
  //);
  const hochEastOffers = offers.filter(
    (offers) => offers.category === "hochtourEast"
  );
  const schitourenOffers = offers.filter(
    (offers) => offers.category === "skitour"
  );

  return (
    <LayoutMain>
      <Background
        image={`${baseImagePath}mountainguide/background/img_guide3.jpg`}
      >
        <MainHeadline text={headline} />
      </Background>
      <Textsection>
        {!selectedOffer ? (
          <>
            <section className="mountainguide-main">
              <div className="mountainguide-wrapper">
                <div className="content-mountg">
                  <h1>Gemeinsam mit einem Bergführer die Alpen erleben!</h1>
                  <p>
		Berg- und Schiführer:innen sind Menschen, die große Teile ihres Lebens privat und beruflich in den Bergen verbringen. Aufbauend darauf werden sie in über drei Jahren intensiver Ausbildung in der Führungsarbeit, Rettungstechnik sowie im Kursbetrieb geschult und schließlich staatlich geprüft.<br/><br/>
		Mit einem Bergführer entscheidet man sich für gewissenhafte Planung und einen Partner am Berg dem man in allen Variationen des alpinen Geländes vertrauen kann. Er steht als Garant für Freude am Tun, größtmögliche Sicherheit, zielorientierte Taktik, die Kompetenz schwere Entscheidungen treffen zu können, ein großes Netzwerk an Informationen, und dafür im Ernstfall bestmöglich mit allen verfügbaren Mitteln zu agieren.<br/><br/>
		Sei es im Fels, Schnee, Eis oder einfach im alpinen Ödland hat man mit einem Bergführer die Chance sich auf sich selbst, die Natur, und das Erleben konzentrieren zu können.<br/><br/>
		Bei KaMikaze Travel bieten wir vollständig geplante kleinere und größere Reisen und Angebote in Begleitung von Bergführern an, und wir vermitteln direkten Kontakt zu einem Bergführer für deine individuellen Zielsetzungen.
                  </p>
                </div>

                <Divider text="Alpines Klettern" />

                <div className="mountainguide-offer">
                  <Row>
                    {climbingOffers.map((offers) => (
                      <Col key={offers.id} xs={12} sm={6} md={3}>
                        <TemplateOffer
                          imgHead={offers.imgHead}
                          title={offers.title}
                          subtitle={offers.subtitle}
                          text={offers.text_overview}
                          price={offers.price}
                          duration={offers.duration}
                          maxGuests={offers.maxGuests}
                          overalleLevel={offers.overalleLevel}
                          onMehrClick={() => handleOfferClick(offers.id)}
                          onBuchenClick={() => handleBookingClick(offers.id)}
                        />
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </section>

            <Divider text="Hochtouren" />

            {/* Second Offer Section */}
            <section className="mountainguide-main">
              <div className="mountainguide-wrapper">
                <div className="mountainguide-offer">
                  <Row>
                    {hochEastOffers.map((offers) => (
                      <Col key={offers.id} xs={12} sm={6} md={3}>
                        <TemplateOffer
                          imgHead={offers.imgHead}
                          title={offers.title}
                          subtitle={offers.subtitle}
                          text={offers.text_overview}
                          price={offers.price}
                          duration={offers.duration}
                          maxGuests={offers.maxGuests}
                          overalleLevel={offers.overalleLevel}
                          onMehrClick={() => handleOfferClick(offers.id)}
                          onBuchenClick={() => handleBookingClick(offers.id)}
                        />
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </section>

            <Divider text="Schitouren/Freeriding" />

            {/* Third Offer Section */}
            <section className="mountainguide-main">
              <div className="mountainguide-wrapper">
                <div className="mountainguide-offer">
                  <Row>
                    {schitourenOffers.map((offers) => (
                      <Col key={offers.id} xs={12} sm={6} md={3}>
                        <TemplateOffer
                          imgHead={offers.imgHead}
                          title={offers.title}
                          subtitle={offers.subtitle}
                          text={offers.text_overview}
                          price={offers.price}
                          duration={offers.duration}
                          maxGuests={offers.maxGuests}
                          overalleLevel={offers.overalleLevel}
                          onMehrClick={() => handleOfferClick(offers.id)}
                          onBuchenClick={() => handleBookingClick(offers.id)}
                        />
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </section>
          </>
        ) : (
          <section className="info-offer-section">
            <InfoOffer
              offers={selectedOffer}
              onReturn={handleReturnClick}
              onBook={handleBookingClick}
            />
          </section>
        )}

        <NoOfferFound
          heading="Kein passendes Angebot gefunden?"
          description="Kein Problem! Ich plane gerne eine individuelle und einzigartige Tour, die ganz auf deine Wünsche zugeschnitten ist. Lass mich deine Vorstellungen wissen, und ich erstelle das perfekte Tourerlebnis für dich."
          buttonText="Schreib mir!"
          buttonLink="/contact"
        />

        <Divider text="Kontakt" />

        <div className="contact">
          <div className="contact-col">
            <h3>Ich freue mich auf deine Nachricht!</h3>
            <p>
              Bei Fragen, Wünschen oder anderen Anliegen, zögere nicht, dich bei
              mir zu melden. Ich erstellen dir gerne ein unverbindliches Angebot
              für deine Tour.
            </p>
            <ul>
              <li>
                <i
                  className="pi pi-envelope"
                  style={{ marginRight: "16px" }}
                ></i>
                <a href="mailto:michael.reisecker@sbg.at" className="text-dark">
                  michael.reisecker@sbg.at
                </a>
              </li>
              <li>
                <i className="pi pi-phone" style={{ marginRight: "16px" }}></i>
                <a href="tel:+43 677 628 847 40" className="text-dark">
                  +43 677 628 847 40
                </a>
              </li>
              <li>
                <i
                  className="pi pi-map-marker"
                  style={{ marginRight: "16px" }}
                ></i>
                Schiliftstraße 504, 5357 Saalbach-Hinterglemm
              </li>
            </ul>
          </div>

          <div className="contact-col-form">
            <Contactform showAddressFields={false} />
          </div>
        </div>
      </Textsection>
    </LayoutMain>
  );
};

export default Mountainguide;
